import { FC } from 'react';
import { AIChatMessage } from '@/types/api/aiChat';

interface ChatMessageProps {
  message: AIChatMessage;
}

const styles = {
  container: (isUser: boolean): React.CSSProperties => ({
    display: 'flex',
    justifyContent: isUser ? 'flex-end' : 'flex-start',
    marginBottom: '12px',
    paddingLeft: isUser ? '40px' : '0',
    paddingRight: isUser ? '0' : '40px',
  }),
  bubble: (isUser: boolean): React.CSSProperties => ({
    maxWidth: '80%',
    padding: '12px 16px',
    borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
    backgroundColor: isUser ? '#1E55E6' : '#F0F0F5',
    color: isUser ? '#FFFFFF' : '#333333',
    fontSize: '14px',
    lineHeight: '1.5',
    wordBreak: 'break-word' as const,
    whiteSpace: 'pre-wrap' as const,
  }),
  time: {
    fontSize: '11px',
    color: '#999',
    marginTop: '4px',
    textAlign: 'right' as const,
  },
  aiIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: '#E3F2FD',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '8px',
    flexShrink: 0,
    fontSize: '16px',
  },
  messageWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
  },
};

export const ChatMessage: FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';
  const isAdmin = message.role === 'admin';

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('ja-JP', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div style={styles.container(isUser)}>
      {!isUser && (
        <div style={styles.messageWrapper}>
          <div style={styles.aiIcon}>{isAdmin ? '?' : '?'}</div>
          <div>
            <div style={styles.bubble(false)}>{message.message}</div>
            <div style={styles.time}>{formatTime(message.created_at)}</div>
          </div>
        </div>
      )}
      {isUser && (
        <div>
          <div style={styles.bubble(true)}>{message.message}</div>
          <div style={styles.time}>{formatTime(message.created_at)}</div>
        </div>
      )}
    </div>
  );
};

interface StreamingMessageProps {
  content: string;
}

export const StreamingMessage: FC<StreamingMessageProps> = ({ content }) => {
  return (
    <div style={styles.container(false)}>
      <div style={styles.messageWrapper}>
        <div style={styles.aiIcon}>?</div>
        <div>
          <div style={styles.bubble(false)}>
            {content}
            <span
              style={{
                display: 'inline-block',
                width: '8px',
                height: '16px',
                backgroundColor: '#666',
                marginLeft: '2px',
                animation: 'blink 1s infinite',
              }}
            />
          </div>
        </div>
      </div>
      <style>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0; }
        }
      `}</style>
    </div>
  );
};
